module.exports = __webpack_public_path__ + "img/meeting-banner.b409036d.jpg";